<template>
  <router-view></router-view>
</template>

<script>
import JwtService from "@/core/services/jwt.service";

export default {
  name: "App", 
  created() {
    let idiomaBrowser = (navigator.language || navigator.userLanguage);

    if(idiomaBrowser) {
      idiomaBrowser = idiomaBrowser.toLowerCase();

      if(idiomaBrowser == "pt-br") {
        this.selecionarIdioma(JwtService.criarObterGenerico("idiomaApp", "ptBR"));
      } else if((idiomaBrowser == "en-us") || (idiomaBrowser == "en")) {
        this.selecionarIdioma(JwtService.criarObterGenerico("idiomaApp", "en"));
      } else if((idiomaBrowser == "es-es") || (idiomaBrowser == "es")) {
        this.selecionarIdioma(JwtService.criarObterGenerico("idiomaApp", "es"));
      } else {
        this.selecionarIdioma(JwtService.criarObterGenerico("idiomaApp", "ptBR"));
      }
    } else {
      this.selecionarIdioma(JwtService.criarObterGenerico("idiomaApp", "ptBR"));
    }
  }, 
  methods: {
    selecionarIdioma(idioma) {
      this.$i18n.locale = idioma;
      
      JwtService.salvarGenerico("idiomaApp", idioma);
    }
  }
}
</script>

<style>

</style>
